"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RECORD_SCHEMA_JSON = exports.RECORDS_JSON = void 0;
exports.RECORDS_JSON = [
    {
        fields: {
            source_ip: '22.182.12.244',
            origin_product: 'Microsoft Azure',
            dest_port: '443',
            category: 'AzureFirewallApplicationRule',
            time: '2023-04-13T22:46:15.682Z',
            operationName: 'AzureFirewallApplicationRuleLog',
            action: 'Deny',
            destination: 'md-wbvnbjlhnxlg.z13.blob.storage.azure.net',
            source_port: '46348',
            protocol: 'HTTPS',
            'properties.msg': 'HTTPS request from 22.182.12.244:46348 to md-wbvnbjlhnxlg.z13.blob.storage.azure.net:443. Action: Deny. No rule matched. Proceeding with default action',
            resourceId: '/SUBSCRIPTIONS/09D6CAF5-641C-42EF-8108-4FD414AA3ABF/RESOURCEGROUPS/RG-AKS-FW/PROVIDERS/MICROSOFT.NETWORK/AZUREFIREWALLS/AKS-AZFW-PROTECTION-FW',
        },
        accountId: null,
        action: null,
        application: null,
        cloud_provider: null,
        cloud_region: null,
        description: 'AzureFirewallApplicationRuleLog',
        dstPort: 443,
        email_sender: null,
        fieldTags: {},
        http_requestHeaders: {},
        http_url: 'md-wbvnbjlhnxlg.z13.blob.storage.azure.net',
        http_url_conditionalFrequency: 1.5231821014504016e-12,
        http_url_entropyFqdn: 4.300072113709065,
        http_url_entropyRootDomain: 2.94770277922009,
        http_url_fqdn: 'md-wbvnbjlhnxlg.z13.blob.storage.azure.net',
        http_url_possibleDynDns: false,
        http_url_rootDomain: 'azure.net',
        http_url_tld: 'net',
        http_userAgent: null,
        listMatches: [],
        matchedItems: [],
        metadata_deviceEventId: 'AzureFirewallApplicationRule',
        metadata_mapperName: 'Azure Firewall Application Rule',
        metadata_mapperUid: 'db25fd08-e994-4f29-8c94-c2ef9ffd68e2',
        metadata_orgId: '0000000006AAD08A',
        metadata_parseTime: 1681417375440,
        metadata_parser: '/Parsers/System/Microsoft/Microsoft Azure JSON',
        metadata_product: 'Azure',
        metadata_productGuid: 'a1225af5-e778-4068-a9a2-47da93d1ff24',
        metadata_sensorZone: 'default',
        metadata_sourceCategory: 'purgatory-v2/alpha/x4Yzha/AnchorOutlierRuleTest/OUTLIER-S00004-TEST-1',
        metadata_sourceMessageId: '2456377680296453054',
        metadata_vendor: 'Microsoft',
        normalizedAction: 'deny',
        normalizedResource: 'network',
        objectClassification: 'Network',
        objectType: 'NetworkProxy',
        srcDevice_ip: '22.182.12.244',
        srcDevice_ip_asnNumber: 749,
        srcDevice_ip_asnOrg: 'Dod Network Information Center',
        srcDevice_ip_city: 'Ashburn',
        srcDevice_ip_countryCode: 'US',
        srcDevice_ip_countryName: 'United States',
        srcDevice_ip_ipv4IntValue: 381029620,
        srcDevice_ip_isInternal: false,
        srcDevice_ip_latitude: 39.043701171875,
        srcDevice_ip_longitude: -77.47419738769531,
        srcDevice_ip_region: 'Virginia',
        srcDevice_ip_version: 4,
        srcPort: 46348,
        success: false,
        tcpProtocol: 'HTTPS',
        threat_name: null,
        timestamp: 1681425975682,
        uid: '0bee0459-407e-527f-8f53-c427b9d6d114',
        user_email: null,
        user_username: null,
        user_username_raw: null,
    },
    {
        fields: {
            source_ip: '22.182.12.244',
            origin_product: 'Microsoft Azure',
            dest_port: '443',
            category: 'AzureFirewallApplicationRule',
            time: '2023-04-13T22:46:11.682Z',
            operationName: 'AzureFirewallApplicationRuleLog',
            action: 'Deny',
            destination: 'md-wbvnbjlhnxlg.z13.blob.storage.azure.net',
            source_port: '46348',
            protocol: 'HTTPS',
            'properties.msg': 'HTTPS request from 22.182.12.244:46348 to md-wbvnbjlhnxlg.z13.blob.storage.azure.net:443. Action: Deny. No rule matched. Proceeding with default action',
            resourceId: '/SUBSCRIPTIONS/09D6CAF5-641C-42EF-8108-4FD414AA3ABF/RESOURCEGROUPS/RG-AKS-FW/PROVIDERS/MICROSOFT.NETWORK/AZUREFIREWALLS/AKS-AZFW-PROTECTION-FW',
        },
        accountId: null,
        action: null,
        application: null,
        cloud_provider: null,
        cloud_region: null,
        description: 'AzureFirewallApplicationRuleLog',
        dstPort: 443,
        email_sender: null,
        fieldTags: {},
        http_requestHeaders: {},
        http_url: 'md-wbvnbjlhnxlg.z13.blob.storage.azure.net',
        http_url_conditionalFrequency: 1.5231821014504016e-12,
        http_url_entropyFqdn: 4.300072113709065,
        http_url_entropyRootDomain: 2.94770277922009,
        http_url_fqdn: 'md-wbvnbjlhnxlg.z13.blob.storage.azure.net',
        http_url_possibleDynDns: false,
        http_url_rootDomain: 'azure.net',
        http_url_tld: 'net',
        http_userAgent: null,
        listMatches: [],
        matchedItems: [],
        metadata_deviceEventId: 'AzureFirewallApplicationRule',
        metadata_mapperName: 'Azure Firewall Application Rule',
        metadata_mapperUid: 'db25fd08-e994-4f29-8c94-c2ef9ffd68e2',
        metadata_orgId: '0000000006AAD08A',
        metadata_parseTime: 1681413232860,
        metadata_parser: '/Parsers/System/Microsoft/Microsoft Azure JSON',
        metadata_product: 'Azure',
        metadata_productGuid: 'a1225af5-e778-4068-a9a2-47da93d1ff24',
        metadata_sensorZone: 'default',
        metadata_sourceCategory: 'purgatory-v2/alpha/d4eGpF/AnchorOutlierRuleTest/OUTLIER-S00004-TEST-1',
        metadata_sourceMessageId: '2456308140699067207',
        metadata_vendor: 'Microsoft',
        normalizedAction: 'deny',
        normalizedResource: 'network',
        objectClassification: 'Network',
        objectType: 'NetworkProxy',
        srcDevice_ip: '22.182.12.244',
        srcDevice_ip_asnNumber: 749,
        srcDevice_ip_asnOrg: 'Dod Network Information Center',
        srcDevice_ip_city: 'Ashburn',
        srcDevice_ip_countryCode: 'US',
        srcDevice_ip_countryName: 'United States',
        srcDevice_ip_ipv4IntValue: 381029620,
        srcDevice_ip_isInternal: false,
        srcDevice_ip_latitude: 39.043701171875,
        srcDevice_ip_longitude: -77.47419738769531,
        srcDevice_ip_region: 'Virginia',
        srcDevice_ip_version: 4,
        srcPort: 46348,
        success: false,
        tcpProtocol: 'HTTPS',
        threat_name: null,
        timestamp: 1681425971682,
        uid: '6a16e6f1-8499-5ca5-8e36-cc1b23eab9ac',
        user_email: null,
        user_username: null,
        user_username_raw: null,
    },
];
exports.RECORD_SCHEMA_JSON = {
    fields: [
        { default: null, name: 'accountId', type: ['null', 'string'] },
        { default: null, name: 'action', type: ['null', 'string'] },
        { default: null, name: 'application', type: ['null', 'string'] },
        { default: null, name: 'authProvider', type: ['null', 'string'] },
        { default: null, name: 'baseImage', type: ['null', 'string'] },
        { default: null, name: 'bro_dceRpc_endpoint', type: ['null', 'string'] },
        { default: null, name: 'bro_dceRpc_namedPipe', type: ['null', 'string'] },
        { default: null, name: 'bro_dceRpc_operation', type: ['null', 'string'] },
        { default: null, name: 'bro_dceRpc_rtt', type: ['null', 'float'] },
        { default: null, name: 'bro_dhcp_assignedIp', type: ['null', 'string'] },
        {
            default: null,
            name: 'bro_dhcp_assignedIp_asnNumber',
            type: ['null', 'int'],
        },
        {
            default: null,
            name: 'bro_dhcp_assignedIp_asnOrg',
            type: ['null', 'string'],
        },
        {
            default: null,
            name: 'bro_dhcp_assignedIp_city',
            type: ['null', 'string'],
        },
        {
            default: null,
            name: 'bro_dhcp_assignedIp_countryCode',
            type: ['null', 'string'],
        },
        {
            default: null,
            name: 'bro_dhcp_assignedIp_countryName',
            type: ['null', 'string'],
        },
        {
            default: null,
            name: 'bro_dhcp_assignedIp_ipv4IntValue',
            type: ['null', 'long'],
        },
        {
            default: null,
            name: 'bro_dhcp_assignedIp_isInternal',
            type: ['null', 'boolean'],
        },
        {
            default: null,
            name: 'bro_dhcp_assignedIp_isp',
            type: ['null', 'string'],
        },
        {
            default: null,
            name: 'bro_dhcp_assignedIp_latitude',
            type: ['null', 'float'],
        },
        {
            default: null,
            name: 'bro_dhcp_assignedIp_location',
            type: ['null', 'string'],
        },
        {
            default: null,
            name: 'bro_dhcp_assignedIp_longitude',
            type: ['null', 'float'],
        },
        {
            default: null,
            name: 'bro_dhcp_assignedIp_region',
            type: ['null', 'string'],
        },
        {
            default: null,
            name: 'bro_dhcp_assignedIp_version',
            type: ['null', 'int'],
        },
        { default: null, name: 'bro_dhcp_leaseTime', type: ['null', 'double'] },
        { default: null, name: 'bro_dhcp_mac', type: ['null', 'string'] },
        {
            default: [],
            name: 'bro_dns_answers',
            type: {
                items: {
                    fields: [
                        { default: null, name: 'resourceRecord', type: ['null', 'string'] },
                        { default: null, name: 'ttl', type: ['null', 'int'] },
                    ],
                    name: 'BroDnsAnswer',
                    namespace: 'com.jask.lib.schemav3',
                    type: 'record',
                },
                type: 'array',
            },
        },
        { default: null, name: 'bro_dns_qclass', type: ['null', 'string'] },
        {
            default: {},
            name: 'bro_file_bytes',
            type: { type: 'map', values: 'string' },
        },
        {
            default: [],
            name: 'bro_file_connUids',
            type: { items: 'string', type: 'array' },
        },
        { default: null, name: 'bro_file_depth', type: ['null', 'int'] },
        { default: null, name: 'bro_file_isOrigin', type: ['null', 'boolean'] },
        { default: null, name: 'bro_file_localOrigin', type: ['null', 'boolean'] },
        { default: null, name: 'bro_file_parentFuid', type: ['null', 'string'] },
        { default: null, name: 'bro_file_source', type: ['null', 'string'] },
        { default: null, name: 'bro_flow_duration', type: ['null', 'float'] },
        { default: null, name: 'bro_flow_history', type: ['null', 'string'] },
        { default: null, name: 'bro_flow_inIpBytes', type: ['null', 'long'] },
        { default: null, name: 'bro_flow_origL2Addr', type: ['null', 'string'] },
        { default: null, name: 'bro_flow_outIpBytes', type: ['null', 'long'] },
        { default: null, name: 'bro_flow_respL2Addr', type: ['null', 'string'] },
        {
            default: [],
            name: 'bro_flow_service',
            type: { items: 'string', type: 'array' },
        },
        { default: null, name: 'bro_ftp_arg', type: ['null', 'string'] },
        {
            default: null,
            name: 'bro_ftp_cmdarg',
            type: [
                'null',
                {
                    fields: [
                        { default: null, name: 'arg', type: ['null', 'string'] },
                        { default: null, name: 'cmd', type: ['null', 'string'] },
                        { default: null, name: 'seq', type: ['null', 'int'] },
                        { default: null, name: 'ts', type: ['null', 'long'] },
                    ],
                    name: 'BroFtpCmdarg',
                    namespace: 'com.jask.lib.schemav3',
                    type: 'record',
                },
            ],
        },
        { default: null, name: 'bro_ftp_command', type: ['null', 'string'] },
        { default: null, name: 'bro_ftp_cwd', type: ['null', 'string'] },
        {
            default: null,
            name: 'bro_ftp_dataChannel',
            type: [
                'null',
                {
                    fields: [
                        { default: null, name: 'originH', type: ['null', 'string'] },
                        { default: null, name: 'originH_asnNumber', type: ['null', 'int'] },
                        { default: null, name: 'originH_asnOrg', type: ['null', 'string'] },
                        { default: null, name: 'originH_city', type: ['null', 'string'] },
                        {
                            default: null,
                            name: 'originH_countryCode',
                            type: ['null', 'string'],
                        },
                        {
                            default: null,
                            name: 'originH_countryName',
                            type: ['null', 'string'],
                        },
                        {
                            default: null,
                            name: 'originH_ipv4IntValue',
                            type: ['null', 'long'],
                        },
                        {
                            default: null,
                            name: 'originH_isInternal',
                            type: ['null', 'boolean'],
                        },
                        { default: null, name: 'originH_isp', type: ['null', 'string'] },
                        {
                            default: null,
                            name: 'originH_latitude',
                            type: ['null', 'float'],
                        },
                        {
                            default: null,
                            name: 'originH_location',
                            type: ['null', 'string'],
                        },
                        {
                            default: null,
                            name: 'originH_longitude',
                            type: ['null', 'float'],
                        },
                        { default: null, name: 'originH_region', type: ['null', 'string'] },
                        { default: null, name: 'originH_version', type: ['null', 'int'] },
                        { default: null, name: 'passive', type: ['null', 'boolean'] },
                        { default: null, name: 'respH', type: ['null', 'string'] },
                        { default: null, name: 'respH_asnNumber', type: ['null', 'int'] },
                        { default: null, name: 'respH_asnOrg', type: ['null', 'string'] },
                        { default: null, name: 'respH_city', type: ['null', 'string'] },
                        {
                            default: null,
                            name: 'respH_countryCode',
                            type: ['null', 'string'],
                        },
                        {
                            default: null,
                            name: 'respH_countryName',
                            type: ['null', 'string'],
                        },
                        {
                            default: null,
                            name: 'respH_ipv4IntValue',
                            type: ['null', 'long'],
                        },
                        {
                            default: null,
                            name: 'respH_isInternal',
                            type: ['null', 'boolean'],
                        },
                        { default: null, name: 'respH_isp', type: ['null', 'string'] },
                        { default: null, name: 'respH_latitude', type: ['null', 'float'] },
                        { default: null, name: 'respH_location', type: ['null', 'string'] },
                        { default: null, name: 'respH_longitude', type: ['null', 'float'] },
                        { default: null, name: 'respH_region', type: ['null', 'string'] },
                        { default: null, name: 'respH_version', type: ['null', 'int'] },
                        { default: null, name: 'respP', type: ['null', 'int'] },
                    ],
                    name: 'BroFtpDataChannel',
                    namespace: 'com.jask.lib.schemav3',
                    type: 'record',
                },
            ],
        },
        { default: null, name: 'bro_ftp_fileSize', type: ['null', 'string'] },
        { default: null, name: 'bro_ftp_fuid', type: ['null', 'string'] },
        {
            default: null,
            name: 'bro_ftp_lastAuthRequested',
            type: ['null', 'string'],
        },
        { default: null, name: 'bro_ftp_mimeType', type: ['null', 'string'] },
        { default: null, name: 'bro_ftp_passive', type: ['null', 'boolean'] },
        { default: null, name: 'bro_ftp_password', type: ['null', 'string'] },
        {
            default: [],
            name: 'bro_ftp_pendingCommands',
            type: { items: 'BroFtpCmdarg', type: 'array' },
        },
        { default: null, name: 'bro_ftp_replyCode', type: ['null', 'int'] },
        { default: null, name: 'bro_ftp_replyMsg', type: ['null', 'string'] },
        {
            default: [],
            name: 'bro_http_cookieVars',
            type: { items: 'string', type: 'array' },
        },
        {
            default: [],
            name: 'bro_http_origFuids',
            type: { items: 'string', type: 'array' },
        },
        {
            default: [],
            name: 'bro_http_origMimeTypes',
            type: { items: 'string', type: 'array' },
        },
        {
            default: null,
            name: 'bro_http_request_contentLength',
            type: ['null', 'int'],
        },
        {
            default: {},
            name: 'bro_http_request_headers',
            type: { type: 'map', values: 'string' },
        },
        {
            default: null,
            name: 'bro_http_request_password',
            type: ['null', 'string'],
        },
        {
            default: [],
            name: 'bro_http_request_proxied',
            type: { items: 'string', type: 'array' },
        },
        {
            default: {},
            name: 'bro_http_response_headers',
            type: { type: 'map', values: 'string' },
        },
        {
            default: null,
            name: 'bro_http_response_infoCode',
            type: ['null', 'int'],
        },
        {
            default: null,
            name: 'bro_http_response_infoMsg',
            type: ['null', 'string'],
        },
        {
            default: [],
            name: 'bro_http_response_respFuids',
            type: { items: 'string', type: 'array' },
        },
        {
            default: [],
            name: 'bro_http_response_respMimeTypes',
            type: { items: 'string', type: 'array' },
        },
        {
            default: [],
            name: 'bro_http_tags',
            type: { items: 'string', type: 'array' },
        },
        { default: null, name: 'bro_http_transDepth', type: ['null', 'int'] },
        {
            default: [],
            name: 'bro_http_uriVars',
            type: { items: 'string', type: 'array' },
        },
        { default: null, name: 'bro_irc_additionalData', type: ['null', 'string'] },
        { default: null, name: 'bro_irc_command', type: ['null', 'string'] },
        { default: null, name: 'bro_irc_nick', type: ['null', 'string'] },
        { default: null, name: 'bro_irc_value', type: ['null', 'string'] },
        { default: null, name: 'bro_kerberos_cipher', type: ['null', 'string'] },
        { default: null, name: 'bro_kerberos_client', type: ['null', 'string'] },
        {
            default: {},
            name: 'bro_kerberos_clientCert',
            type: { type: 'map', values: 'string' },
        },
        { default: null, name: 'bro_kerberos_errorCode', type: ['null', 'int'] },
        { default: null, name: 'bro_kerberos_errorMsg', type: ['null', 'string'] },
        {
            default: null,
            name: 'bro_kerberos_forwardable',
            type: ['null', 'boolean'],
        },
        { default: null, name: 'bro_kerberos_from', type: ['null', 'float'] },
        {
            default: null,
            name: 'bro_kerberos_renewable',
            type: ['null', 'boolean'],
        },
        {
            default: null,
            name: 'bro_kerberos_requestType',
            type: ['null', 'string'],
        },
        {
            default: {},
            name: 'bro_kerberos_serverCert',
            type: { type: 'map', values: 'string' },
        },
        { default: null, name: 'bro_kerberos_service', type: ['null', 'string'] },
        { default: null, name: 'bro_kerberos_success', type: ['null', 'boolean'] },
        { default: null, name: 'bro_kerberos_til', type: ['null', 'float'] },
        { default: null, name: 'bro_ntlm_domainname', type: ['null', 'string'] },
        { default: null, name: 'bro_ntlm_status', type: ['null', 'string'] },
        { default: null, name: 'bro_ntlm_success', type: ['null', 'boolean'] },
        { default: null, name: 'bro_protocol', type: ['null', 'string'] },
        { default: null, name: 'bro_radius_connectInfo', type: ['null', 'string'] },
        { default: null, name: 'bro_radius_mac', type: ['null', 'string'] },
        { default: null, name: 'bro_radius_remoteIp', type: ['null', 'string'] },
        {
            default: null,
            name: 'bro_radius_remoteIp_asnNumber',
            type: ['null', 'int'],
        },
        {
            default: null,
            name: 'bro_radius_remoteIp_asnOrg',
            type: ['null', 'string'],
        },
        {
            default: null,
            name: 'bro_radius_remoteIp_city',
            type: ['null', 'string'],
        },
        {
            default: null,
            name: 'bro_radius_remoteIp_countryCode',
            type: ['null', 'string'],
        },
        {
            default: null,
            name: 'bro_radius_remoteIp_countryName',
            type: ['null', 'string'],
        },
        {
            default: null,
            name: 'bro_radius_remoteIp_ipv4IntValue',
            type: ['null', 'long'],
        },
        {
            default: null,
            name: 'bro_radius_remoteIp_isInternal',
            type: ['null', 'boolean'],
        },
        {
            default: null,
            name: 'bro_radius_remoteIp_isp',
            type: ['null', 'string'],
        },
        {
            default: null,
            name: 'bro_radius_remoteIp_latitude',
            type: ['null', 'float'],
        },
        {
            default: null,
            name: 'bro_radius_remoteIp_location',
            type: ['null', 'string'],
        },
        {
            default: null,
            name: 'bro_radius_remoteIp_longitude',
            type: ['null', 'float'],
        },
        {
            default: null,
            name: 'bro_radius_remoteIp_region',
            type: ['null', 'string'],
        },
        {
            default: null,
            name: 'bro_radius_remoteIp_version',
            type: ['null', 'int'],
        },
        { default: null, name: 'bro_radius_result', type: ['null', 'string'] },
        { default: null, name: 'bro_rdp_certCount', type: ['null', 'int'] },
        { default: null, name: 'bro_rdp_certPermanent', type: ['null', 'boolean'] },
        { default: null, name: 'bro_rdp_certType', type: ['null', 'string'] },
        { default: null, name: 'bro_rdp_clientBuild', type: ['null', 'string'] },
        {
            default: null,
            name: 'bro_rdp_clientDigProductId',
            type: ['null', 'string'],
        },
        { default: null, name: 'bro_rdp_clientName', type: ['null', 'string'] },
        { default: null, name: 'bro_rdp_cookie', type: ['null', 'string'] },
        { default: null, name: 'bro_rdp_desktopHeight', type: ['null', 'string'] },
        { default: null, name: 'bro_rdp_desktopWidth', type: ['null', 'string'] },
        { default: null, name: 'bro_rdp_done', type: ['null', 'boolean'] },
        {
            default: null,
            name: 'bro_rdp_encryptionLevel',
            type: ['null', 'string'],
        },
        {
            default: null,
            name: 'bro_rdp_encryptionMethod',
            type: ['null', 'string'],
        },
        { default: null, name: 'bro_rdp_keyboardLayout', type: ['null', 'string'] },
        {
            default: null,
            name: 'bro_rdp_requestedColorDepth',
            type: ['null', 'string'],
        },
        { default: null, name: 'bro_rdp_result', type: ['null', 'string'] },
        {
            default: null,
            name: 'bro_rdp_securityProtocol',
            type: ['null', 'string'],
        },
        { default: null, name: 'bro_rdp_ssl', type: ['null', 'boolean'] },
        {
            default: null,
            name: 'bro_rfb_authenticationMethod',
            type: ['null', 'string'],
        },
        {
            default: null,
            name: 'bro_rfb_authenticationSuccessful',
            type: ['null', 'boolean'],
        },
        {
            default: null,
            name: 'bro_rfb_clientMajorVersion',
            type: ['null', 'string'],
        },
        {
            default: null,
            name: 'bro_rfb_clientMinorVersion',
            type: ['null', 'string'],
        },
        { default: null, name: 'bro_rfb_desktopName', type: ['null', 'string'] },
        { default: null, name: 'bro_rfb_height', type: ['null', 'int'] },
        {
            default: null,
            name: 'bro_rfb_serverMajorVersion',
            type: ['null', 'string'],
        },
        {
            default: null,
            name: 'bro_rfb_serverMinorVersion',
            type: ['null', 'string'],
        },
        { default: null, name: 'bro_rfb_sharedSession', type: ['null', 'boolean'] },
        { default: null, name: 'bro_rfb_width', type: ['null', 'int'] },
        {
            default: {},
            name: 'bro_sip_headers',
            type: { type: 'map', values: 'string' },
        },
        { default: null, name: 'bro_sip_requestBodyLength', type: ['null', 'int'] },
        { default: null, name: 'bro_sip_requestFrom', type: ['null', 'string'] },
        { default: null, name: 'bro_sip_requestMethod', type: ['null', 'string'] },
        {
            default: [],
            name: 'bro_sip_requestPath',
            type: { items: 'string', type: 'array' },
        },
        { default: null, name: 'bro_sip_requestTo', type: ['null', 'string'] },
        { default: null, name: 'bro_sip_requestUri', type: ['null', 'string'] },
        {
            default: null,
            name: 'bro_sip_responseBodyLength',
            type: ['null', 'int'],
        },
        { default: null, name: 'bro_sip_responseFrom', type: ['null', 'string'] },
        {
            default: [],
            name: 'bro_sip_responsePath',
            type: { items: 'string', type: 'array' },
        },
        { default: null, name: 'bro_sip_responseTo', type: ['null', 'string'] },
        { default: null, name: 'bro_sip_statusCode', type: ['null', 'int'] },
        { default: null, name: 'bro_sip_statusMsg', type: ['null', 'string'] },
        {
            default: null,
            name: 'bro_smb_command',
            type: [
                'null',
                {
                    fields: [
                        { default: null, name: 'argument', type: ['null', 'string'] },
                        { default: null, name: 'name', type: ['null', 'string'] },
                        { default: null, name: 'rtt', type: ['null', 'double'] },
                        { default: null, name: 'status', type: ['null', 'string'] },
                        { default: null, name: 'subCommand', type: ['null', 'string'] },
                        { default: null, name: 'treePath', type: ['null', 'string'] },
                        { default: null, name: 'treeService', type: ['null', 'string'] },
                        { default: null, name: 'username', type: ['null', 'string'] },
                        { default: null, name: 'version', type: ['null', 'string'] },
                    ],
                    name: 'BroSmbCommand',
                    namespace: 'com.jask.lib.schemav3',
                    type: 'record',
                },
            ],
        },
        {
            default: null,
            name: 'bro_smb_file',
            type: [
                'null',
                {
                    fields: [
                        { default: null, name: 'action', type: ['null', 'string'] },
                        {
                            default: {},
                            name: 'timestamps',
                            type: { type: 'map', values: 'long' },
                        },
                    ],
                    name: 'BroSmbFile',
                    namespace: 'com.jask.lib.schemav3',
                    type: 'record',
                },
            ],
        },
        {
            default: null,
            name: 'bro_smb_mapping',
            type: [
                'null',
                {
                    fields: [
                        { default: null, name: 'fileSystem', type: ['null', 'string'] },
                        { default: null, name: 'path', type: ['null', 'string'] },
                        { default: null, name: 'service', type: ['null', 'string'] },
                        { default: null, name: 'shareType', type: ['null', 'string'] },
                    ],
                    name: 'BroSmbMapping',
                    namespace: 'com.jask.lib.schemav3',
                    type: 'record',
                },
            ],
        },
        {
            default: null,
            name: 'bro_smb_tree',
            type: [
                'null',
                {
                    fields: [
                        { default: null, name: 'fileSystem', type: ['null', 'string'] },
                        { default: null, name: 'path', type: ['null', 'string'] },
                        { default: null, name: 'service', type: ['null', 'string'] },
                        { default: null, name: 'shareType', type: ['null', 'string'] },
                        { default: null, name: 'timestamp', type: ['null', 'long'] },
                    ],
                    name: 'BroSmbTree',
                    namespace: 'com.jask.lib.schemav3',
                    type: 'record',
                },
            ],
        },
        {
            default: null,
            name: 'bro_smtp_headers',
            type: [
                'null',
                {
                    fields: [
                        { default: null, name: 'date', type: ['null', 'string'] },
                        { default: null, name: 'firstReceived', type: ['null', 'string'] },
                        { default: null, name: 'from', type: ['null', 'string'] },
                        { default: null, name: 'helo', type: ['null', 'string'] },
                        { default: null, name: 'inReplyTo', type: ['null', 'string'] },
                        { default: null, name: 'mailfrom', type: ['null', 'string'] },
                        { default: null, name: 'msgId', type: ['null', 'string'] },
                        {
                            default: [],
                            name: 'rcptto',
                            type: { items: 'string', type: 'array' },
                        },
                        { default: null, name: 'replyTo', type: ['null', 'string'] },
                        { default: null, name: 'secondReceived', type: ['null', 'string'] },
                        { default: null, name: 'subject', type: ['null', 'string'] },
                        {
                            default: [],
                            name: 'to',
                            type: { items: 'string', type: 'array' },
                        },
                        { default: null, name: 'xOriginatingIp', type: ['null', 'string'] },
                        {
                            default: null,
                            name: 'xOriginatingIp_asnNumber',
                            type: ['null', 'int'],
                        },
                        {
                            default: null,
                            name: 'xOriginatingIp_asnOrg',
                            type: ['null', 'string'],
                        },
                        {
                            default: null,
                            name: 'xOriginatingIp_city',
                            type: ['null', 'string'],
                        },
                        {
                            default: null,
                            name: 'xOriginatingIp_countryCode',
                            type: ['null', 'string'],
                        },
                        {
                            default: null,
                            name: 'xOriginatingIp_countryName',
                            type: ['null', 'string'],
                        },
                        {
                            default: null,
                            name: 'xOriginatingIp_ipv4IntValue',
                            type: ['null', 'long'],
                        },
                        {
                            default: null,
                            name: 'xOriginatingIp_isInternal',
                            type: ['null', 'boolean'],
                        },
                        {
                            default: null,
                            name: 'xOriginatingIp_isp',
                            type: ['null', 'string'],
                        },
                        {
                            default: null,
                            name: 'xOriginatingIp_latitude',
                            type: ['null', 'float'],
                        },
                        {
                            default: null,
                            name: 'xOriginatingIp_location',
                            type: ['null', 'string'],
                        },
                        {
                            default: null,
                            name: 'xOriginatingIp_longitude',
                            type: ['null', 'float'],
                        },
                        {
                            default: null,
                            name: 'xOriginatingIp_region',
                            type: ['null', 'string'],
                        },
                        {
                            default: null,
                            name: 'xOriginatingIp_version',
                            type: ['null', 'int'],
                        },
                    ],
                    name: 'BroSmtpHeaders',
                    namespace: 'com.jask.lib.schemav3',
                    type: 'record',
                },
            ],
        },
        { default: null, name: 'bro_smtp_isWebmail', type: ['null', 'boolean'] },
        { default: null, name: 'bro_smtp_lastReply', type: ['null', 'string'] },
        { default: null, name: 'bro_smtp_path', type: ['null', 'string'] },
        { default: null, name: 'bro_smtp_tls', type: ['null', 'boolean'] },
        { default: null, name: 'bro_smtp_transDepth', type: ['null', 'int'] },
        { default: null, name: 'bro_smtp_userAgent', type: ['null', 'string'] },
        { default: null, name: 'bro_snmp_community', type: ['null', 'string'] },
        { default: null, name: 'bro_snmp_displayString', type: ['null', 'string'] },
        { default: null, name: 'bro_snmp_duration', type: ['null', 'double'] },
        { default: null, name: 'bro_snmp_getBulkRequests', type: ['null', 'int'] },
        { default: null, name: 'bro_snmp_getRequests', type: ['null', 'int'] },
        { default: null, name: 'bro_snmp_getResponses', type: ['null', 'int'] },
        { default: null, name: 'bro_snmp_setRequests', type: ['null', 'int'] },
        { default: null, name: 'bro_snmp_upSince', type: ['null', 'long'] },
        { default: null, name: 'bro_snmp_version', type: ['null', 'string'] },
        { default: null, name: 'bro_socks_boundIp', type: ['null', 'string'] },
        {
            default: null,
            name: 'bro_socks_boundIp_asnNumber',
            type: ['null', 'int'],
        },
        {
            default: null,
            name: 'bro_socks_boundIp_asnOrg',
            type: ['null', 'string'],
        },
        { default: null, name: 'bro_socks_boundIp_city', type: ['null', 'string'] },
        {
            default: null,
            name: 'bro_socks_boundIp_countryCode',
            type: ['null', 'string'],
        },
        {
            default: null,
            name: 'bro_socks_boundIp_countryName',
            type: ['null', 'string'],
        },
        {
            default: null,
            name: 'bro_socks_boundIp_ipv4IntValue',
            type: ['null', 'long'],
        },
        {
            default: null,
            name: 'bro_socks_boundIp_isInternal',
            type: ['null', 'boolean'],
        },
        { default: null, name: 'bro_socks_boundIp_isp', type: ['null', 'string'] },
        {
            default: null,
            name: 'bro_socks_boundIp_latitude',
            type: ['null', 'float'],
        },
        {
            default: null,
            name: 'bro_socks_boundIp_location',
            type: ['null', 'string'],
        },
        {
            default: null,
            name: 'bro_socks_boundIp_longitude',
            type: ['null', 'float'],
        },
        {
            default: null,
            name: 'bro_socks_boundIp_region',
            type: ['null', 'string'],
        },
        { default: null, name: 'bro_socks_boundIp_version', type: ['null', 'int'] },
        { default: null, name: 'bro_socks_boundName', type: ['null', 'string'] },
        { default: null, name: 'bro_socks_boundPort', type: ['null', 'int'] },
        { default: null, name: 'bro_socks_password', type: ['null', 'string'] },
        { default: null, name: 'bro_socks_requestIp', type: ['null', 'string'] },
        {
            default: null,
            name: 'bro_socks_requestIp_asnNumber',
            type: ['null', 'int'],
        },
        {
            default: null,
            name: 'bro_socks_requestIp_asnOrg',
            type: ['null', 'string'],
        },
        {
            default: null,
            name: 'bro_socks_requestIp_city',
            type: ['null', 'string'],
        },
        {
            default: null,
            name: 'bro_socks_requestIp_countryCode',
            type: ['null', 'string'],
        },
        {
            default: null,
            name: 'bro_socks_requestIp_countryName',
            type: ['null', 'string'],
        },
        {
            default: null,
            name: 'bro_socks_requestIp_ipv4IntValue',
            type: ['null', 'long'],
        },
        {
            default: null,
            name: 'bro_socks_requestIp_isInternal',
            type: ['null', 'boolean'],
        },
        {
            default: null,
            name: 'bro_socks_requestIp_isp',
            type: ['null', 'string'],
        },
        {
            default: null,
            name: 'bro_socks_requestIp_latitude',
            type: ['null', 'float'],
        },
        {
            default: null,
            name: 'bro_socks_requestIp_location',
            type: ['null', 'string'],
        },
        {
            default: null,
            name: 'bro_socks_requestIp_longitude',
            type: ['null', 'float'],
        },
        {
            default: null,
            name: 'bro_socks_requestIp_region',
            type: ['null', 'string'],
        },
        {
            default: null,
            name: 'bro_socks_requestIp_version',
            type: ['null', 'int'],
        },
        { default: null, name: 'bro_socks_requestName', type: ['null', 'string'] },
        { default: null, name: 'bro_socks_requestPort', type: ['null', 'int'] },
        { default: null, name: 'bro_socks_status', type: ['null', 'string'] },
        { default: null, name: 'bro_socks_version', type: ['null', 'int'] },
        { default: null, name: 'bro_ssh_authSuccess', type: ['null', 'boolean'] },
        {
            default: null,
            name: 'bro_ssh_cipherAlgorithm',
            type: ['null', 'string'],
        },
        { default: null, name: 'bro_ssh_client', type: ['null', 'string'] },
        {
            default: null,
            name: 'bro_ssh_compressionAlgorithm',
            type: ['null', 'string'],
        },
        {
            default: null,
            name: 'bro_ssh_hostKeyAlgorithm',
            type: ['null', 'string'],
        },
        {
            default: null,
            name: 'bro_ssh_keyExchangeAlgorithm',
            type: ['null', 'string'],
        },
        { default: null, name: 'bro_ssh_macAlgorithm', type: ['null', 'string'] },
        { default: null, name: 'bro_ssh_server', type: ['null', 'string'] },
        { default: null, name: 'bro_ssh_version', type: ['null', 'int'] },
        {
            default: [],
            name: 'bro_ssl_certChainFuids',
            type: { items: 'string', type: 'array' },
        },
        { default: null, name: 'bro_ssl_cipher', type: ['null', 'string'] },
        {
            default: [],
            name: 'bro_ssl_clientCertChainFuids',
            type: { items: 'string', type: 'array' },
        },
        { default: null, name: 'bro_ssl_curve', type: ['null', 'string'] },
        { default: null, name: 'bro_ssl_established', type: ['null', 'boolean'] },
        { default: null, name: 'bro_ssl_issuer', type: ['null', 'string'] },
        { default: null, name: 'bro_ssl_nextProtocol', type: ['null', 'string'] },
        { default: null, name: 'bro_ssl_resumed', type: ['null', 'boolean'] },
        { default: null, name: 'bro_ssl_serverName', type: ['null', 'string'] },
        {
            default: null,
            name: 'bro_ssl_serverName_alexaRank',
            type: ['null', 'long'],
        },
        {
            default: null,
            name: 'bro_ssl_serverName_conditionalFrequency',
            type: ['null', 'double'],
        },
        {
            default: null,
            name: 'bro_ssl_serverName_entropyFqdn',
            type: ['null', 'double'],
        },
        {
            default: null,
            name: 'bro_ssl_serverName_entropyRootDomain',
            type: ['null', 'double'],
        },
        {
            default: null,
            name: 'bro_ssl_serverName_entropySubDomain',
            type: ['null', 'double'],
        },
        {
            default: null,
            name: 'bro_ssl_serverName_fqdn',
            type: ['null', 'string'],
        },
        {
            default: null,
            name: 'bro_ssl_serverName_possibleDga',
            type: ['null', 'boolean'],
        },
        {
            default: null,
            name: 'bro_ssl_serverName_possibleDynDns',
            type: ['null', 'boolean'],
        },
        {
            default: null,
            name: 'bro_ssl_serverName_rootDomain',
            type: ['null', 'string'],
        },
        { default: null, name: 'bro_ssl_serverName_tld', type: ['null', 'string'] },
        { default: null, name: 'bro_ssl_subject', type: ['null', 'string'] },
        { default: null, name: 'bro_ssl_version', type: ['null', 'string'] },
        { default: null, name: 'bytesIn', type: ['null', 'long'] },
        { default: null, name: 'bytesOut', type: ['null', 'long'] },
        { default: null, name: 'cause', type: ['null', 'string'] },
        { default: null, name: 'changeTarget', type: ['null', 'string'] },
        { default: null, name: 'changeType', type: ['null', 'string'] },
        { default: null, name: 'cloud_provider', type: ['null', 'string'] },
        { default: null, name: 'cloud_region', type: ['null', 'string'] },
        { default: null, name: 'cloud_service', type: ['null', 'string'] },
        { default: null, name: 'cloud_zone', type: ['null', 'string'] },
        { default: null, name: 'commandLine', type: ['null', 'string'] },
        { default: {}, name: 'cseSignal', type: { type: 'map', values: 'string' } },
        { default: null, name: 'day', type: ['null', 'int'] },
        { default: null, name: 'description', type: ['null', 'string'] },
        { default: null, name: 'device_container_id', type: ['null', 'string'] },
        { default: null, name: 'device_container_name', type: ['null', 'string'] },
        {
            default: null,
            name: 'device_container_runtime',
            type: ['null', 'string'],
        },
        { default: null, name: 'device_hostname', type: ['null', 'string'] },
        { default: null, name: 'device_hostname_raw', type: ['null', 'string'] },
        { default: null, name: 'device_image', type: ['null', 'string'] },
        { default: null, name: 'device_ip', type: ['null', 'string'] },
        { default: null, name: 'device_ip_asnNumber', type: ['null', 'int'] },
        { default: null, name: 'device_ip_asnOrg', type: ['null', 'string'] },
        { default: null, name: 'device_ip_city', type: ['null', 'string'] },
        { default: null, name: 'device_ip_countryCode', type: ['null', 'string'] },
        { default: null, name: 'device_ip_countryName', type: ['null', 'string'] },
        { default: null, name: 'device_ip_ipv4IntValue', type: ['null', 'long'] },
        { default: null, name: 'device_ip_isInternal', type: ['null', 'boolean'] },
        { default: null, name: 'device_ip_isp', type: ['null', 'string'] },
        { default: null, name: 'device_ip_latitude', type: ['null', 'float'] },
        { default: null, name: 'device_ip_location', type: ['null', 'string'] },
        { default: null, name: 'device_ip_longitude', type: ['null', 'float'] },
        { default: null, name: 'device_ip_region', type: ['null', 'string'] },
        { default: null, name: 'device_ip_version', type: ['null', 'int'] },
        { default: null, name: 'device_k8s_deployment', type: ['null', 'string'] },
        { default: null, name: 'device_k8s_namespace', type: ['null', 'string'] },
        {
            default: null,
            name: 'device_k8s_normalizedDeploymentName',
            type: ['null', 'string'],
        },
        {
            default: null,
            name: 'device_k8s_normalizedPodName',
            type: ['null', 'string'],
        },
        {
            default: null,
            name: 'device_k8s_normalizedReplicaSetName',
            type: ['null', 'string'],
        },
        { default: null, name: 'device_k8s_pod', type: ['null', 'string'] },
        { default: null, name: 'device_k8s_replicaSet', type: ['null', 'string'] },
        { default: null, name: 'device_mac', type: ['null', 'string'] },
        { default: null, name: 'device_natIp', type: ['null', 'string'] },
        { default: null, name: 'device_natIp_asnNumber', type: ['null', 'int'] },
        { default: null, name: 'device_natIp_asnOrg', type: ['null', 'string'] },
        { default: null, name: 'device_natIp_city', type: ['null', 'string'] },
        {
            default: null,
            name: 'device_natIp_countryCode',
            type: ['null', 'string'],
        },
        {
            default: null,
            name: 'device_natIp_countryName',
            type: ['null', 'string'],
        },
        {
            default: null,
            name: 'device_natIp_ipv4IntValue',
            type: ['null', 'long'],
        },
        {
            default: null,
            name: 'device_natIp_isInternal',
            type: ['null', 'boolean'],
        },
        { default: null, name: 'device_natIp_isp', type: ['null', 'string'] },
        { default: null, name: 'device_natIp_latitude', type: ['null', 'float'] },
        { default: null, name: 'device_natIp_location', type: ['null', 'string'] },
        { default: null, name: 'device_natIp_longitude', type: ['null', 'float'] },
        { default: null, name: 'device_natIp_region', type: ['null', 'string'] },
        { default: null, name: 'device_natIp_version', type: ['null', 'int'] },
        { default: null, name: 'device_osName', type: ['null', 'string'] },
        { default: null, name: 'device_type', type: ['null', 'string'] },
        { default: null, name: 'device_uniqueId', type: ['null', 'string'] },
        { default: null, name: 'dns_query', type: ['null', 'string'] },
        { default: null, name: 'dns_queryDomain', type: ['null', 'string'] },
        {
            default: null,
            name: 'dns_queryDomain_alexaRank',
            type: ['null', 'long'],
        },
        {
            default: null,
            name: 'dns_queryDomain_conditionalFrequency',
            type: ['null', 'double'],
        },
        {
            default: null,
            name: 'dns_queryDomain_entropyFqdn',
            type: ['null', 'double'],
        },
        {
            default: null,
            name: 'dns_queryDomain_entropyRootDomain',
            type: ['null', 'double'],
        },
        {
            default: null,
            name: 'dns_queryDomain_entropySubDomain',
            type: ['null', 'double'],
        },
        { default: null, name: 'dns_queryDomain_fqdn', type: ['null', 'string'] },
        {
            default: null,
            name: 'dns_queryDomain_possibleDga',
            type: ['null', 'boolean'],
        },
        {
            default: null,
            name: 'dns_queryDomain_possibleDynDns',
            type: ['null', 'boolean'],
        },
        {
            default: null,
            name: 'dns_queryDomain_rootDomain',
            type: ['null', 'string'],
        },
        { default: null, name: 'dns_queryDomain_tld', type: ['null', 'string'] },
        { default: null, name: 'dns_queryType', type: ['null', 'string'] },
        { default: null, name: 'dns_reply', type: ['null', 'string'] },
        { default: null, name: 'dns_replyDomain', type: ['null', 'string'] },
        {
            default: null,
            name: 'dns_replyDomain_alexaRank',
            type: ['null', 'long'],
        },
        {
            default: null,
            name: 'dns_replyDomain_conditionalFrequency',
            type: ['null', 'double'],
        },
        {
            default: null,
            name: 'dns_replyDomain_entropyFqdn',
            type: ['null', 'double'],
        },
        {
            default: null,
            name: 'dns_replyDomain_entropyRootDomain',
            type: ['null', 'double'],
        },
        {
            default: null,
            name: 'dns_replyDomain_entropySubDomain',
            type: ['null', 'double'],
        },
        { default: null, name: 'dns_replyDomain_fqdn', type: ['null', 'string'] },
        {
            default: null,
            name: 'dns_replyDomain_possibleDga',
            type: ['null', 'boolean'],
        },
        {
            default: null,
            name: 'dns_replyDomain_possibleDynDns',
            type: ['null', 'boolean'],
        },
        {
            default: null,
            name: 'dns_replyDomain_rootDomain',
            type: ['null', 'string'],
        },
        { default: null, name: 'dns_replyDomain_tld', type: ['null', 'string'] },
        { default: null, name: 'dns_replyIp', type: ['null', 'string'] },
        { default: null, name: 'dns_replyIp_asnNumber', type: ['null', 'int'] },
        { default: null, name: 'dns_replyIp_asnOrg', type: ['null', 'string'] },
        { default: null, name: 'dns_replyIp_city', type: ['null', 'string'] },
        {
            default: null,
            name: 'dns_replyIp_countryCode',
            type: ['null', 'string'],
        },
        {
            default: null,
            name: 'dns_replyIp_countryName',
            type: ['null', 'string'],
        },
        { default: null, name: 'dns_replyIp_ipv4IntValue', type: ['null', 'long'] },
        {
            default: null,
            name: 'dns_replyIp_isInternal',
            type: ['null', 'boolean'],
        },
        { default: null, name: 'dns_replyIp_isp', type: ['null', 'string'] },
        { default: null, name: 'dns_replyIp_latitude', type: ['null', 'float'] },
        { default: null, name: 'dns_replyIp_location', type: ['null', 'string'] },
        { default: null, name: 'dns_replyIp_longitude', type: ['null', 'float'] },
        { default: null, name: 'dns_replyIp_region', type: ['null', 'string'] },
        { default: null, name: 'dns_replyIp_version', type: ['null', 'int'] },
        { default: null, name: 'dns_returnCode', type: ['null', 'string'] },
        { default: null, name: 'dstDevice_container_id', type: ['null', 'string'] },
        {
            default: null,
            name: 'dstDevice_container_name',
            type: ['null', 'string'],
        },
        {
            default: null,
            name: 'dstDevice_container_runtime',
            type: ['null', 'string'],
        },
        { default: null, name: 'dstDevice_hostname', type: ['null', 'string'] },
        { default: null, name: 'dstDevice_hostname_raw', type: ['null', 'string'] },
        { default: null, name: 'dstDevice_image', type: ['null', 'string'] },
        { default: null, name: 'dstDevice_ip', type: ['null', 'string'] },
        { default: null, name: 'dstDevice_ip_asnNumber', type: ['null', 'int'] },
        { default: null, name: 'dstDevice_ip_asnOrg', type: ['null', 'string'] },
        { default: null, name: 'dstDevice_ip_city', type: ['null', 'string'] },
        {
            default: null,
            name: 'dstDevice_ip_countryCode',
            type: ['null', 'string'],
        },
        {
            default: null,
            name: 'dstDevice_ip_countryName',
            type: ['null', 'string'],
        },
        {
            default: null,
            name: 'dstDevice_ip_ipv4IntValue',
            type: ['null', 'long'],
        },
        {
            default: null,
            name: 'dstDevice_ip_isInternal',
            type: ['null', 'boolean'],
        },
        { default: null, name: 'dstDevice_ip_isp', type: ['null', 'string'] },
        { default: null, name: 'dstDevice_ip_latitude', type: ['null', 'float'] },
        { default: null, name: 'dstDevice_ip_location', type: ['null', 'string'] },
        { default: null, name: 'dstDevice_ip_longitude', type: ['null', 'float'] },
        { default: null, name: 'dstDevice_ip_region', type: ['null', 'string'] },
        { default: null, name: 'dstDevice_ip_version', type: ['null', 'int'] },
        {
            default: null,
            name: 'dstDevice_k8s_deployment',
            type: ['null', 'string'],
        },
        {
            default: null,
            name: 'dstDevice_k8s_namespace',
            type: ['null', 'string'],
        },
        {
            default: null,
            name: 'dstDevice_k8s_normalizedDeploymentName',
            type: ['null', 'string'],
        },
        {
            default: null,
            name: 'dstDevice_k8s_normalizedPodName',
            type: ['null', 'string'],
        },
        {
            default: null,
            name: 'dstDevice_k8s_normalizedReplicaSetName',
            type: ['null', 'string'],
        },
        { default: null, name: 'dstDevice_k8s_pod', type: ['null', 'string'] },
        {
            default: null,
            name: 'dstDevice_k8s_replicaSet',
            type: ['null', 'string'],
        },
        { default: null, name: 'dstDevice_mac', type: ['null', 'string'] },
        { default: null, name: 'dstDevice_natIp', type: ['null', 'string'] },
        { default: null, name: 'dstDevice_natIp_asnNumber', type: ['null', 'int'] },
        { default: null, name: 'dstDevice_natIp_asnOrg', type: ['null', 'string'] },
        { default: null, name: 'dstDevice_natIp_city', type: ['null', 'string'] },
        {
            default: null,
            name: 'dstDevice_natIp_countryCode',
            type: ['null', 'string'],
        },
        {
            default: null,
            name: 'dstDevice_natIp_countryName',
            type: ['null', 'string'],
        },
        {
            default: null,
            name: 'dstDevice_natIp_ipv4IntValue',
            type: ['null', 'long'],
        },
        {
            default: null,
            name: 'dstDevice_natIp_isInternal',
            type: ['null', 'boolean'],
        },
        { default: null, name: 'dstDevice_natIp_isp', type: ['null', 'string'] },
        {
            default: null,
            name: 'dstDevice_natIp_latitude',
            type: ['null', 'float'],
        },
        {
            default: null,
            name: 'dstDevice_natIp_location',
            type: ['null', 'string'],
        },
        {
            default: null,
            name: 'dstDevice_natIp_longitude',
            type: ['null', 'float'],
        },
        { default: null, name: 'dstDevice_natIp_region', type: ['null', 'string'] },
        { default: null, name: 'dstDevice_natIp_version', type: ['null', 'int'] },
        { default: null, name: 'dstDevice_osName', type: ['null', 'string'] },
        { default: null, name: 'dstDevice_type', type: ['null', 'string'] },
        { default: null, name: 'dstDevice_uniqueId', type: ['null', 'string'] },
        { default: null, name: 'dstPort', type: ['null', 'int'] },
        { default: null, name: 'email_messageId', type: ['null', 'string'] },
        { default: null, name: 'email_recipient', type: ['null', 'string'] },
        { default: null, name: 'email_sender', type: ['null', 'string'] },
        { default: null, name: 'email_subject', type: ['null', 'string'] },
        { default: null, name: 'errorCode', type: ['null', 'string'] },
        { default: null, name: 'errorText', type: ['null', 'string'] },
        {
            default: {},
            name: 'fieldTags',
            type: { type: 'map', values: { items: 'string', type: 'array' } },
        },
        { default: {}, name: 'fields', type: { type: 'map', values: 'string' } },
        { default: null, name: 'file_basename', type: ['null', 'string'] },
        { default: null, name: 'file_hash_imphash', type: ['null', 'string'] },
        { default: null, name: 'file_hash_md5', type: ['null', 'string'] },
        { default: null, name: 'file_hash_pehash', type: ['null', 'string'] },
        { default: null, name: 'file_hash_sha1', type: ['null', 'string'] },
        { default: null, name: 'file_hash_sha256', type: ['null', 'string'] },
        { default: null, name: 'file_hash_ssdeep', type: ['null', 'string'] },
        { default: null, name: 'file_mimeType', type: ['null', 'string'] },
        { default: null, name: 'file_path', type: ['null', 'string'] },
        { default: null, name: 'file_size', type: ['null', 'long'] },
        { default: null, name: 'file_uid', type: ['null', 'string'] },
        { default: null, name: 'flowState', type: ['null', 'string'] },
        { default: 'record', name: 'friendlyName', type: 'string' },
        { default: null, name: 'fromUser_authDomain', type: ['null', 'string'] },
        { default: null, name: 'fromUser_email', type: ['null', 'string'] },
        { default: null, name: 'fromUser_role', type: ['null', 'string'] },
        { default: null, name: 'fromUser_userId', type: ['null', 'string'] },
        { default: null, name: 'fromUser_username', type: ['null', 'string'] },
        { default: null, name: 'fromUser_username_raw', type: ['null', 'string'] },
        { default: null, name: 'fromUser_username_role', type: ['null', 'string'] },
        { default: null, name: 'hour', type: ['null', 'int'] },
        { default: null, name: 'http_category', type: ['null', 'string'] },
        { default: null, name: 'http_contentLength', type: ['null', 'int'] },
        { default: null, name: 'http_hostname', type: ['null', 'string'] },
        { default: null, name: 'http_method', type: ['null', 'string'] },
        { default: null, name: 'http_referer', type: ['null', 'string'] },
        { default: null, name: 'http_referer_alexaRank', type: ['null', 'long'] },
        {
            default: null,
            name: 'http_referer_conditionalFrequency',
            type: ['null', 'double'],
        },
        {
            default: null,
            name: 'http_referer_entropyFqdn',
            type: ['null', 'double'],
        },
        {
            default: null,
            name: 'http_referer_entropyRootDomain',
            type: ['null', 'double'],
        },
        {
            default: null,
            name: 'http_referer_entropySubDomain',
            type: ['null', 'double'],
        },
        { default: null, name: 'http_referer_fqdn', type: ['null', 'string'] },
        { default: null, name: 'http_referer_path', type: ['null', 'string'] },
        {
            default: null,
            name: 'http_referer_possibleDga',
            type: ['null', 'boolean'],
        },
        {
            default: null,
            name: 'http_referer_possibleDynDns',
            type: ['null', 'boolean'],
        },
        { default: null, name: 'http_referer_protocol', type: ['null', 'string'] },
        {
            default: null,
            name: 'http_referer_rootDomain',
            type: ['null', 'string'],
        },
        { default: null, name: 'http_referer_tld', type: ['null', 'string'] },
        {
            default: {},
            name: 'http_requestHeaders',
            type: { type: 'map', values: 'string' },
        },
        {
            default: null,
            name: 'http_response_contentLength',
            type: ['null', 'int'],
        },
        {
            default: null,
            name: 'http_response_contentType',
            type: ['null', 'string'],
        },
        { default: null, name: 'http_response_statusCode', type: ['null', 'int'] },
        {
            default: null,
            name: 'http_response_statusText',
            type: ['null', 'string'],
        },
        { default: null, name: 'http_url', type: ['null', 'string'] },
        { default: null, name: 'http_url_alexaRank', type: ['null', 'long'] },
        {
            default: null,
            name: 'http_url_conditionalFrequency',
            type: ['null', 'double'],
        },
        { default: null, name: 'http_url_entropyFqdn', type: ['null', 'double'] },
        {
            default: null,
            name: 'http_url_entropyRootDomain',
            type: ['null', 'double'],
        },
        {
            default: null,
            name: 'http_url_entropySubDomain',
            type: ['null', 'double'],
        },
        { default: null, name: 'http_url_fqdn', type: ['null', 'string'] },
        { default: null, name: 'http_url_path', type: ['null', 'string'] },
        { default: null, name: 'http_url_possibleDga', type: ['null', 'boolean'] },
        {
            default: null,
            name: 'http_url_possibleDynDns',
            type: ['null', 'boolean'],
        },
        { default: null, name: 'http_url_protocol', type: ['null', 'string'] },
        { default: null, name: 'http_url_rootDomain', type: ['null', 'string'] },
        { default: null, name: 'http_url_tld', type: ['null', 'string'] },
        { default: null, name: 'http_userAgent', type: ['null', 'string'] },
        { default: null, name: 'ipProtocol', type: ['null', 'string'] },
        {
            default: [],
            name: 'listMatches',
            type: { items: 'string', type: 'array' },
        },
        { default: null, name: 'logonType', type: ['null', 'string'] },
        {
            default: [],
            name: 'matchedItems',
            type: {
                items: {
                    fields: [
                        { name: 'active', type: 'boolean' },
                        { default: null, name: 'expires', type: ['null', 'float'] },
                        { name: 'id', type: 'string' },
                        { name: 'listId', type: 'string' },
                        {
                            default: null,
                            name: 'meta',
                            type: [
                                'null',
                                {
                                    fields: [
                                        {
                                            default: null,
                                            name: 'created',
                                            type: [
                                                'null',
                                                {
                                                    fields: [
                                                        { name: 'username', type: 'string' },
                                                        { name: 'when', type: 'float' },
                                                    ],
                                                    name: 'MatchedUserAudit',
                                                    namespace: 'com.jask.lib.schemav3',
                                                    type: 'record',
                                                },
                                            ],
                                        },
                                        { name: 'description', type: 'string' },
                                        {
                                            default: null,
                                            name: 'updated',
                                            type: ['null', 'com.jask.lib.schemav3.MatchedUserAudit'],
                                        },
                                    ],
                                    name: 'MatchedMeta',
                                    namespace: 'com.jask.lib.schemav3',
                                    type: 'record',
                                },
                            ],
                        },
                        { name: 'target', type: 'string' },
                        { name: 'value', type: 'string' },
                    ],
                    name: 'MatchedItem',
                    namespace: 'com.jask.lib.schemav3',
                    type: 'record',
                },
                type: 'array',
            },
        },
        { default: null, name: 'metadata_defaultTz', type: ['null', 'int'] },
        { default: null, name: 'metadata_deviceEventId', type: ['null', 'string'] },
        { default: null, name: 'metadata_mapperName', type: ['null', 'string'] },
        { default: null, name: 'metadata_mapperUid', type: ['null', 'string'] },
        { default: null, name: 'metadata_orgId', type: ['null', 'string'] },
        { default: null, name: 'metadata_parseTime', type: ['null', 'long'] },
        { default: null, name: 'metadata_parser', type: ['null', 'string'] },
        { default: null, name: 'metadata_product', type: ['null', 'string'] },
        { default: null, name: 'metadata_productGuid', type: ['null', 'string'] },
        { default: null, name: 'metadata_receiptTime', type: ['null', 'long'] },
        { default: null, name: 'metadata_relayHostname', type: ['null', 'string'] },
        { default: null, name: 'metadata_relayIp', type: ['null', 'string'] },
        { default: null, name: 'metadata_schemaVersion', type: ['null', 'int'] },
        { name: 'metadata_sensorId', type: 'string' },
        {
            default: {},
            name: 'metadata_sensorInformation',
            type: { type: 'map', values: 'string' },
        },
        { default: null, name: 'metadata_sensorZone', type: ['null', 'string'] },
        {
            default: null,
            name: 'metadata_sourceCategory',
            type: ['null', 'string'],
        },
        {
            default: null,
            name: 'metadata_sourceMessageId',
            type: ['null', 'string'],
        },
        { default: null, name: 'metadata_tenantId', type: ['null', 'string'] },
        { default: null, name: 'metadata_vendor', type: ['null', 'string'] },
        { default: null, name: 'mfa', type: ['null', 'boolean'] },
        { default: null, name: 'moduleType', type: ['null', 'string'] },
        { default: null, name: 'month', type: ['null', 'int'] },
        { default: null, name: 'normalizedAction', type: ['null', 'string'] },
        { default: null, name: 'normalizedCause', type: ['null', 'string'] },
        { default: null, name: 'normalizedResource', type: ['null', 'string'] },
        { default: null, name: 'normalizedSeverity', type: ['null', 'int'] },
        {
            default: null,
            name: 'normalizedSeverity_description',
            type: ['null', 'string'],
        },
        { name: 'objectType', type: 'string' },
        { default: null, name: 'packetsIn', type: ['null', 'long'] },
        { default: null, name: 'packetsOut', type: ['null', 'long'] },
        { default: null, name: 'parentBaseImage', type: ['null', 'string'] },
        { default: null, name: 'parentCommandLine', type: ['null', 'string'] },
        { default: null, name: 'parentPid', type: ['null', 'int'] },
        { default: null, name: 'pid', type: ['null', 'int'] },
        { default: null, name: 'processUid', type: ['null', 'string'] },
        { default: null, name: 'resource', type: ['null', 'string'] },
        { default: null, name: 'resourceType', type: ['null', 'string'] },
        { default: null, name: 'sessionId', type: ['null', 'string'] },
        { default: null, name: 'severity', type: ['null', 'string'] },
        { default: null, name: 'sourceUid', type: ['null', 'string'] },
        { default: null, name: 'srcDevice_container_id', type: ['null', 'string'] },
        {
            default: null,
            name: 'srcDevice_container_name',
            type: ['null', 'string'],
        },
        {
            default: null,
            name: 'srcDevice_container_runtime',
            type: ['null', 'string'],
        },
        { default: null, name: 'srcDevice_hostname', type: ['null', 'string'] },
        { default: null, name: 'srcDevice_hostname_raw', type: ['null', 'string'] },
        { default: null, name: 'srcDevice_image', type: ['null', 'string'] },
        { default: null, name: 'srcDevice_ip', type: ['null', 'string'] },
        { default: null, name: 'srcDevice_ip_asnNumber', type: ['null', 'int'] },
        { default: null, name: 'srcDevice_ip_asnOrg', type: ['null', 'string'] },
        { default: null, name: 'srcDevice_ip_city', type: ['null', 'string'] },
        {
            default: null,
            name: 'srcDevice_ip_countryCode',
            type: ['null', 'string'],
        },
        {
            default: null,
            name: 'srcDevice_ip_countryName',
            type: ['null', 'string'],
        },
        {
            default: null,
            name: 'srcDevice_ip_ipv4IntValue',
            type: ['null', 'long'],
        },
        {
            default: null,
            name: 'srcDevice_ip_isInternal',
            type: ['null', 'boolean'],
        },
        { default: null, name: 'srcDevice_ip_isp', type: ['null', 'string'] },
        { default: null, name: 'srcDevice_ip_latitude', type: ['null', 'float'] },
        { default: null, name: 'srcDevice_ip_location', type: ['null', 'string'] },
        { default: null, name: 'srcDevice_ip_longitude', type: ['null', 'float'] },
        { default: null, name: 'srcDevice_ip_region', type: ['null', 'string'] },
        { default: null, name: 'srcDevice_ip_version', type: ['null', 'int'] },
        {
            default: null,
            name: 'srcDevice_k8s_deployment',
            type: ['null', 'string'],
        },
        {
            default: null,
            name: 'srcDevice_k8s_namespace',
            type: ['null', 'string'],
        },
        {
            default: null,
            name: 'srcDevice_k8s_normalizedDeploymentName',
            type: ['null', 'string'],
        },
        {
            default: null,
            name: 'srcDevice_k8s_normalizedPodName',
            type: ['null', 'string'],
        },
        {
            default: null,
            name: 'srcDevice_k8s_normalizedReplicaSetName',
            type: ['null', 'string'],
        },
        { default: null, name: 'srcDevice_k8s_pod', type: ['null', 'string'] },
        {
            default: null,
            name: 'srcDevice_k8s_replicaSet',
            type: ['null', 'string'],
        },
        { default: null, name: 'srcDevice_mac', type: ['null', 'string'] },
        { default: null, name: 'srcDevice_natIp', type: ['null', 'string'] },
        { default: null, name: 'srcDevice_natIp_asnNumber', type: ['null', 'int'] },
        { default: null, name: 'srcDevice_natIp_asnOrg', type: ['null', 'string'] },
        { default: null, name: 'srcDevice_natIp_city', type: ['null', 'string'] },
        {
            default: null,
            name: 'srcDevice_natIp_countryCode',
            type: ['null', 'string'],
        },
        {
            default: null,
            name: 'srcDevice_natIp_countryName',
            type: ['null', 'string'],
        },
        {
            default: null,
            name: 'srcDevice_natIp_ipv4IntValue',
            type: ['null', 'long'],
        },
        {
            default: null,
            name: 'srcDevice_natIp_isInternal',
            type: ['null', 'boolean'],
        },
        { default: null, name: 'srcDevice_natIp_isp', type: ['null', 'string'] },
        {
            default: null,
            name: 'srcDevice_natIp_latitude',
            type: ['null', 'float'],
        },
        {
            default: null,
            name: 'srcDevice_natIp_location',
            type: ['null', 'string'],
        },
        {
            default: null,
            name: 'srcDevice_natIp_longitude',
            type: ['null', 'float'],
        },
        { default: null, name: 'srcDevice_natIp_region', type: ['null', 'string'] },
        { default: null, name: 'srcDevice_natIp_version', type: ['null', 'int'] },
        { default: null, name: 'srcDevice_osName', type: ['null', 'string'] },
        { default: null, name: 'srcDevice_type', type: ['null', 'string'] },
        { default: null, name: 'srcDevice_uniqueId', type: ['null', 'string'] },
        { default: null, name: 'srcPort', type: ['null', 'int'] },
        { default: null, name: 'success', type: ['null', 'boolean'] },
        { default: null, name: 'targetUser_authDomain', type: ['null', 'string'] },
        { default: null, name: 'targetUser_email', type: ['null', 'string'] },
        { default: null, name: 'targetUser_role', type: ['null', 'string'] },
        { default: null, name: 'targetUser_userId', type: ['null', 'string'] },
        { default: null, name: 'targetUser_username', type: ['null', 'string'] },
        {
            default: null,
            name: 'targetUser_username_raw',
            type: ['null', 'string'],
        },
        {
            default: null,
            name: 'targetUser_username_role',
            type: ['null', 'string'],
        },
        { default: null, name: 'tcpProtocol', type: ['null', 'string'] },
        { default: null, name: 'threat_category', type: ['null', 'string'] },
        { default: null, name: 'threat_identifier', type: ['null', 'string'] },
        { default: null, name: 'threat_name', type: ['null', 'string'] },
        { default: null, name: 'threat_referenceUrl', type: ['null', 'string'] },
        { default: null, name: 'threat_ruleType', type: ['null', 'string'] },
        { default: null, name: 'threat_signalName', type: ['null', 'string'] },
        { default: null, name: 'threat_signalSummary', type: ['null', 'string'] },
        { name: 'timestamp', type: 'long' },
        { name: 'uid', type: 'string' },
        { default: null, name: 'user_authDomain', type: ['null', 'string'] },
        { default: null, name: 'user_email', type: ['null', 'string'] },
        { default: null, name: 'user_role', type: ['null', 'string'] },
        { default: null, name: 'user_userId', type: ['null', 'string'] },
        { default: null, name: 'user_username', type: ['null', 'string'] },
        { default: null, name: 'user_username_raw', type: ['null', 'string'] },
        { default: null, name: 'user_username_role', type: ['null', 'string'] },
        { default: null, name: 'vuln_bugtraq', type: ['null', 'string'] },
        { default: null, name: 'vuln_cert', type: ['null', 'string'] },
        { default: null, name: 'vuln_cve', type: ['null', 'string'] },
        { default: null, name: 'vuln_cvss', type: ['null', 'string'] },
        { default: null, name: 'vuln_name', type: ['null', 'string'] },
        { default: null, name: 'vuln_reference', type: ['null', 'string'] },
        { default: null, name: 'year', type: ['null', 'int'] },
    ],
    name: 'Record',
    namespace: 'com.jask.lib.schemav3',
    type: 'record',
};
